if (!customElements.get('toggle-tab')) {
  class ToggleTab extends HTMLElement {
    constructor() {
      super();
      this.activeTabId = null;
    }

    connectedCallback() {
      const buttons = document.querySelectorAll('[data-toggle-tab-action="open"]');
      const templates = document.querySelectorAll('template[data-tab-content]');

      if (!buttons.length || !templates.length) return;

      // Find the default open tab or the first button
      const defaultButton = [...buttons].find(button => button.dataset.toggleTabOpen === 'true') || buttons[0];
      if (defaultButton) {
        this.openTab(defaultButton.dataset.toggleTabId, buttons);
      }

      // Attach click event to each button
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          this.openTab(button.dataset.toggleTabId, buttons);
        });
      });
    }

    openTab(tabId, buttons) {
      if (this.activeTabId === tabId) return;

      // Update button active classes
      buttons.forEach(button => {
        if (button.dataset.toggleTabId === tabId) {
          button.classList.add('active');
        } else {
          button.classList.remove('active');
        }
      });

      // Swap the content in the toggle-tab
      const template = document.querySelector(`template[data-tab-content="${tabId}"]`);
      if (template) {
        this.innerHTML = template.innerHTML;
      }

      this.activeTabId = tabId;
    }
  }

  // Define the custom element
  customElements.define('toggle-tab', ToggleTab);
}
